import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-triangle-up",
  templateUrl: "./med-icon-triangle-up.component.html",
})
export class MedIconTriangleUpComponent extends SvgMixinComponent {}
